export default "__VITE_ASSET__NrHtRsO7__"